import EstimatedProfitsError from './EstimatedProfitsError';
class EstimatedProfitsInvalidPropertyID extends EstimatedProfitsError {
    propertyId;
    constructor(propertyId, options) {
        super('INVALID_CROWDFUNDING_PROPERTY_ID', options);
        this.propertyId = propertyId;
    }
}
export default EstimatedProfitsInvalidPropertyID;
